const numerals = ['영', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
const unitNames = ['', '만', '억', '조', '경'];

const convertKoreanSmallNumber = (num) => {
  if (num === 0) return '';
  let result = '';
  
  const thousands = Math.floor(num / 1000);
  if (thousands > 0) result += numerals[thousands] + '천 ';
  
  const hundreds = Math.floor((num % 1000) / 100);
  if (hundreds > 0) result += numerals[hundreds] + '백 ';
  
  const tens = Math.floor((num % 100) / 10);
  if (tens > 0) result += numerals[tens] + '십 ';
  
  const ones = num % 10;
  if (ones > 0) result += numerals[ones];
  
  return result.trim();
};

const convertKoreanInteger = (num) => {
  const unitIndices = [0, 4, 8, 12, 16]; 
  let result = '';
  let tempNum = num;

  for (let i = unitNames.length - 1; i >= 0; i--) {
    const power = Math.pow(10, unitIndices[i]);
    if (tempNum >= power) {
      const quotient = Math.floor(tempNum / power);
      if (i > 0) {
        if (quotient > 0) {
           result += convertKoreanSmallNumber(quotient % 10000) + ' ' + unitNames[i] + ' ';
        }
      } else {
        const remainder = quotient % 10000;
        if (remainder > 0 || result === '') {
           result += convertKoreanSmallNumber(remainder);
        }
      }
      tempNum %= power;
    }
  }
  return result.trim();
};

export const convertToKorean = (num) => {
  const isNegative = num < 0;
  num = Math.abs(num);
  
  let result = isNegative ? '마이너스 ' : '';
  
  const integerPart = Math.floor(num);
  const decimalPart = Math.round((num - integerPart) * 100) / 100;
  
  if (integerPart === 0 && decimalPart === 0) return '영';
  
  if (integerPart > 0) {
    result += convertKoreanInteger(integerPart);
  } else if (integerPart === 0) {
    result += '영';
  }
  
  if (decimalPart > 0) {
    result += ' 점 ';
    const decimalStr = decimalPart.toFixed(2).substring(2);
    if (decimalStr === '00') {
      result += '영 영';
    } else {
      const digits = [];
      for (let i = 0; i < decimalStr.length; i++) {
        digits.push(numerals[parseInt(decimalStr[i])]);
      }
      result += digits.join(' ');
    }
  }
  
  return result.trim();
};